import React from 'react';
import { styled } from '@linaria/react';
import getSafeBottomSpacingValue from 'utils/getSafeBottomSpacing';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { cssTheme } from '@daedalus/atlas/themes';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
export const HEADER_HEIGHT_MOBILE = 65;
const HEADER_HEIGHT_FILTERS_MOBILE = 45;
const _exp = /*#__PURE__*/() => Flex.Column;
export const LayoutWrapper = /*#__PURE__*/styled(_exp())({
  name: "LayoutWrapper",
  class: "luy1eua",
  propsAsIs: true
});
export const HeaderWrapper = /*#__PURE__*/styled('div')({
  name: "HeaderWrapper",
  class: "hb60c9n",
  propsAsIs: false
});
export const MainContentWrapper = /*#__PURE__*/styled('section')({
  name: "MainContentWrapper",
  class: "m1auschr",
  propsAsIs: false
});
const _exp3 = /*#__PURE__*/() => ({
  isSafari
}) => getSafeBottomSpacingValue({
  spacing: cssTheme.layout.spacing.s600,
  isSafari
});
export const FooterWrapper = /*#__PURE__*/styled('div')({
  name: "FooterWrapper",
  class: "foexrvj",
  propsAsIs: false,
  vars: {
    "foexrvj-0": [_exp3()]
  }
});
const _exp5 = /*#__PURE__*/() => ({
  searchMobileHeaderHeight
}) => searchMobileHeaderHeight;
const FixedHeaderSpacer = /*#__PURE__*/styled('div')({
  name: "FixedHeaderSpacer",
  class: "follzq1",
  propsAsIs: false,
  vars: {
    "follzq1-0": [_exp5(), "px"]
  }
});
interface Props {
  mobileHeaderIsFixed: boolean;
}

// Basic level brands do not display the filter/sort/map bar, so we need to account for the height reduction
const getWhiteLabelMarginReduction = (withMarginReduction: boolean) => withMarginReduction ? HEADER_HEIGHT_FILTERS_MOBILE : 0;

// Some brands have a collapsing header, so we need to account for the expanded height
const getExtraHeaderHeight = (withExtraHeaderHeight: boolean) => withExtraHeaderHeight ? HEADER_HEIGHT_MOBILE : 0;
const getSearchMobileHeaderHeight = (withMarginReduction: boolean, withExtraHeaderHeight: boolean) => HEADER_HEIGHT_MOBILE + HEADER_HEIGHT_FILTERS_MOBILE - getWhiteLabelMarginReduction(withMarginReduction) + getExtraHeaderHeight(withExtraHeaderHeight);
export const HeaderSpacer = ({
  mobileHeaderIsFixed
}: Props) => {
  const {
    brandHasFilters,
    brandHasCollapsingHeader
  } = useBrand();
  const searchMobileHeaderHeight = getSearchMobileHeaderHeight(!brandHasFilters, brandHasCollapsingHeader);
  if (mobileHeaderIsFixed) {
    return <FixedHeaderSpacer searchMobileHeaderHeight={searchMobileHeaderHeight} />;
  }
  return null;
};

require("./mobileStyles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./mobileStyles.tsx");